module.exports = __webpack_public_path__ + "static/media/Path 3570.7bc459dc.svg";